import { render, staticRenderFns } from "./CompanyDataUpdateTaskQueueLevel2.vue?vue&type=template&id=0481bfbc&scoped=true&"
import script from "./CompanyDataUpdateTaskQueueLevel2.vue?vue&type=script&lang=js&"
export * from "./CompanyDataUpdateTaskQueueLevel2.vue?vue&type=script&lang=js&"
import style0 from "./CompanyDataUpdateTaskQueueLevel2.vue?vue&type=style&index=0&id=0481bfbc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0481bfbc",
  null
  
)

export default component.exports